import React, { Component } from "react";
import PdfView from "../CustomFields/PdfView";
import { COLOR_WARNING } from "../../Colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { getGeneralPermissionValidator } from "../../helpers/getGeneralPermissionValidator";

class EnvioArquivo extends Component {
  canViewFile() {
      return this.props.hasGeneralPermission("arquivo");
  }

  render() {
    if (this.props.envio.tipo === "Dispensado") {
      return (
        <div
          style={{
            fontSize: "15px",
            color: COLOR_WARNING,
            textAlign: "center",
          }}
          className="font-weight-500 cursor-pointer py-5"
        >
          <FontAwesomeIcon icon="exclamation-triangle" /> Envio do documento{" "}
          {this.props.documento.nome} foi dispensado
        </div>
      );
    }

    if (!this.canViewFile()) {
      return (
        <div
          style={{
            fontSize: "15px",
            color: COLOR_WARNING,
            textAlign: "center",
          }}
          className="font-weight-500 cursor-pointer py-5"
        >
          <FontAwesomeIcon icon="exclamation-triangle" /> Seu usuário não tem permissão para visualizar os arquivos.
        </div>
      );
    }

    return (
      <PdfView
        name={this.props.documento.nome}
        filial={this.props.filial}
        contrato={this.props.contrato}
        funcionario={this.props.funcionario}
        idDocumentoEnvio={this.props.envio.idDocumentoEnvio}
        documento={this.props.documento.idDocumento}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  permissoes: state.permissions.permissoes,
  hasGeneralPermission: getGeneralPermissionValidator(state),
});

export default connect(mapStateToProps)(EnvioArquivo);
